<template>
  <div id="notificaciones">
    <v-tabs v-model="tab_activo" v-show="(!loading && tab_activo == 0) || tab_activo == 1" color="blue-grey" dark
      slider-color="error" class="elevation-12">
      <v-tab ripple>
        No leídos
      </v-tab>
      <v-tab ripple>
        Leídos
      </v-tab>
      <v-tab-item>
        <v-container>
          <v-expansion-panel popout focusable dark>
            <template v-if="notificaciones.length">
              <div class="text-xs-center pb-3">
                <v-btn flat dark small color="blue-grey">
                  {{ pagina_notificaciones * 7 - 6 }} - {{ pagina_notificaciones * 7 }} ({{ total_notificaciones }})
                </v-btn>
                <v-btn @click="newPage('back', 'notificaciones')" v-show="!(pagina_notificaciones <= 1)" round dark
                  small color="blue-grey">
                  <v-icon dark>navigate_before</v-icon>
                </v-btn>
                <v-btn @click="newPage('next', 'notificaciones')"
                  v-show="!((pagina_notificaciones * 7) >= total_notificaciones)" round dark small color="blue-grey">
                  <v-icon dark>navigate_next</v-icon>
                </v-btn>
                <v-btn @click="refresh()" round dark small color="blue-grey">
                  <v-icon dark>loop</v-icon>
                </v-btn>
              </div>
              <v-expansion-panel-content v-for="(item, i) in notificaciones" :key="i">
                <div v-if="observaciones[i] === ''" slot="header">
                  <strong><span style="color:#2196F3;">APROBACIÓN</span>&nbsp;&nbsp;&nbsp;{{ getNotificacionHeader(item)
                  }}</strong>
                </div>
                <div v-else slot="header">
                  <strong><span style="color:#2196F3;">MENSAJE</span>&nbsp;&nbsp;&nbsp;{{ getNotificacionHeader(item)
                  }}</strong>
                </div>
                <v-card light>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md6>
                        <p>
                          <strong>Beneficiario:</strong> {{ item.nombre }} ({{ item.usuario }})
                        </p>
                        <p>
                          <strong>Tipo de solicitud:</strong> {{ getTipoDesc(item.tipo) }}
                        </p>
                        <p>
                          <strong>Movimiento:</strong> {{ item.movimiento }}
                        </p>
                        <p>
                          <strong>Fecha:</strong> {{ item.fecha_registro }}
                        </p>
                        <p>
                          <strong>Firma:</strong> {{ item.firma }}
                        </p>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <p v-if="item.resumen && item.resumen.unidad_negocio">
                          <strong>Unidad de negocio:</strong> {{ item.resumen.unidad_negocio }}
                        </p>
                        <p v-if="item.resumen && item.resumen.ubicacion">
                          <strong>Ubicación:</strong> {{ item.resumen.ubicacion }}
                        </p>
                        <p v-if="item.resumen && item.resumen.puesto">
                          <strong>Puesto:</strong> {{ item.resumen.puesto }}
                        </p>
                        <p v-if="item.resumen && item.resumen.centro_costos">
                          <strong>Centro de costos:</strong> {{ item.resumen.centro_costos }}
                        </p>
                        <p v-if="item.resumen && item.resumen.empresa">
                          <strong>Empresa:</strong> {{ item.resumen.empresa }}
                        </p>
                        <p v-if="item.resumen && item.resumen.monto">
                          <strong>Monto:</strong> {{ '$ ' +
                            item.resumen.monto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                        <p v-if="item.resumen && item.resumen.dias_viaje">
                          <strong>Días de viaje:</strong> {{ item.resumen.dias_viaje }}
                        </p>
                        <p v-if="item.resumen && item.resumen.destino">
                          <strong>Destino:</strong> {{ item.resumen.destino }}
                        </p>
                        <p v-if="item.resumen && item.resumen.importe_anticipo">
                          <strong>Importe de Anticipo:</strong> {{ '$ ' +
                            item.resumen.importe_anticipo.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                        <p v-if="item.resumen && item.resumen.importe_comprobado">
                          <strong>Importe Comprobado:</strong> {{ '$ ' +
                            item.resumen.importe_comprobado.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                        <p v-if="item.resumen && item.resumen.importe_restante">
                          <strong>Importe Restante:</strong> {{ '$ ' +
                            item.resumen.importe_restante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                      </v-flex>
                    </v-layout>
                    <p v-if="observaciones[i] !== ''">
                      <strong>Observaciones:</strong> {{ item.observaciones }}
                    </p>
                    <v-text-field v-else v-model="notificaciones[i].observaciones"
                      :error-messages="observacionesErrors(i)"
                      @input="$v.notificaciones.$each[i].observaciones.$touch()"
                      @blur="$v.notificaciones.$each[i].observaciones.$touch()" label="Observaciones"></v-text-field>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="blue-grey" @click="showDetailReq(notificaciones[i].id, notificaciones[i])">
                      Detalle
                      <v-icon right dark>description</v-icon>
                    </v-btn>
                    <template v-if="observaciones[i] === ''">
                      <v-btn dark color="error" @click="notificacion = notificaciones[i]; questionReject = true">
                        Rechazar
                        <v-icon right dark>clear</v-icon>
                      </v-btn>
                      <v-btn dark color="success" @click="notificacion = notificaciones[i]; questionApprove = true">
                        Aprobar
                        <v-icon right dark>check</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn dark color="blue-grey" @click="notificacion = notificaciones[i]; questionRemove = true">
                        Marcar como leído
                      </v-btn>
                    </template>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </template>
            <template v-else>
              <v-card light>
                <v-card-text>
                  <div class="text-xs-center">
                    <v-btn v-if="!loading" @click="refresh()" round dark small color="blue-grey">
                      <v-icon dark>loop</v-icon>
                    </v-btn>
                    <p>
                    <h3 v-if="!loading">No se obtuvieron elementos</h3>
                    <h3 v-else>Cargando elementos...</h3>
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </v-expansion-panel>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-expansion-panel popout focusable>
            <template v-if="leidos.length">
              <div class="text-xs-center pb-3">
                <v-btn flat dark small color="blue-grey">
                  {{ pagina_leidos * 7 - 6 }} - {{ pagina_leidos * 7 }} ({{ total_leidos }})
                </v-btn>
                <v-btn @click="newPage('back', 'leidos')" v-show="!(pagina_leidos <= 1)" round dark small
                  color="blue-grey">
                  <v-icon dark>navigate_before</v-icon>
                </v-btn>
                <v-btn @click="newPage('next', 'leidos')" v-show="!((pagina_leidos * 7) >= total_leidos)" round dark
                  small color="blue-grey">
                  <v-icon dark>navigate_next</v-icon>
                </v-btn>
                <v-btn @click="refresh()" round dark small color="blue-grey">
                  <v-icon dark>loop</v-icon>
                </v-btn>
              </div>
              <v-expansion-panel-content v-for="(item, i) in leidos" :key="i">
                <div slot="header"><strong>{{ item.tipo + ' - ' + item.movimiento + ' - ' + item.fecha_actualizacion
                }}</strong></div>
                <v-card dark>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md6>
                        <p>
                          <strong>Beneficiario:</strong> {{ item.nombre }} ({{ item.usuario }})
                        </p>
                        <p>
                          <strong>Tipo de solicitud:</strong> {{ item.tipo }}
                        </p>
                        <p>
                          <strong>Movimiento:</strong> {{ item.movimiento }}
                        </p>
                        <p>
                          <strong>Fecha:</strong> {{ item.fecha_registro }}
                        </p>
                        <p>
                          <strong>Firma:</strong> {{ item.firma }}
                        </p>
                        <p>
                          <strong>Observaciones:</strong> {{ item.observaciones }}
                        </p>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <p v-if="item.resumen && item.resumen.unidad_negocio">
                          <strong>Unidad de negocio:</strong> {{ item.resumen.unidad_negocio }}
                        </p>
                        <p v-if="item.resumen && item.resumen.ubicacion">
                          <strong>Ubicación:</strong> {{ item.resumen.ubicacion }}
                        </p>
                        <p v-if="item.resumen && item.resumen.puesto">
                          <strong>Puesto:</strong> {{ item.resumen.puesto }}
                        </p>
                        <p v-if="item.resumen && item.resumen.centro_costos">
                          <strong>Centro de costos:</strong> {{ item.resumen.centro_costos }}
                        </p>
                        <p v-if="item.resumen && item.resumen.empresa">
                          <strong>Empresa:</strong> {{ item.resumen.empresa }}
                        </p>
                        <p v-if="item.resumen && item.resumen.monto">
                          <strong>Monto:</strong> {{ '$ ' +
                            item.resumen.monto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                        <p v-if="item.resumen && item.resumen.dias_viaje">
                          <strong>Días de viaje:</strong> {{ item.resumen.dias_viaje }}
                        </p>
                        <p v-if="item.resumen && item.resumen.destino">
                          <strong>Destino:</strong> {{ item.resumen.destino }}
                        </p>
                        <p v-if="item.resumen && item.resumen.importe_anticipo">
                          <strong>Importe de Anticipo:</strong> {{ '$ ' +
                            item.resumen.importe_anticipo.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                        <p v-if="item.resumen && item.resumen.importe_comprobado">
                          <strong>Importe Comprobado:</strong> {{ '$ ' +
                            item.resumen.importe_comprobado.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                        <p v-if="item.resumen && item.resumen.importe_restante">
                          <strong>Importe Restante:</strong> {{ '$ ' +
                            item.resumen.importe_restante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark flat @click="showDetailReq(leidos[i].id)">
                      Detalle
                      <v-icon right dark>description</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </template>
            <template v-else>
              <v-card light>
                <v-card-text>
                  <div class="text-xs-center">
                    <v-btn v-if="!loading" @click="refresh()" round dark small color="blue-grey">
                      <v-icon dark>loop</v-icon>
                    </v-btn>
                    <p>
                    <h3 v-if="!loading">No se obtuvieron elementos</h3>
                    <h3 v-else>Cargando elementos...</h3>
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </v-expansion-panel>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="dialogDetailReq" @keydown.esc="handleEsc" persistent min-width="500"
      :max-width="!tipoReposicion ? 1300 : null"
      :class="`dialogo-detalle ${tipoReposicion ? 'dialogo-detalle--wide' : ''}`"
      :content-class="`dialogo-detalle__content ${tipoReposicion ? 'dialogo-detalle__content--scroll' : ''}`">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de la solicitud {{ tituloPlus }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="closeDetailReq()">Cerrar</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <template v-if="tipoSolicitudAmex === true">
              <v-text-field label="Fecha de solicitud" box readonly
                :value="solicitudAmex.fecha_creacion"></v-text-field>
              <v-text-field label="Tipo de Solicitud" box readonly :value="'Gastos AMEX (Solicitud)'"></v-text-field>
              <v-text-field label="Empresa" box readonly :value="solicitudAmex.empresa.nombre"></v-text-field>
              <v-text-field label="Centro de costo" box readonly
                :value="solicitudAmex.centro_costo.nombre"></v-text-field>
              <v-text-field label="Departamento" box readonly :value="solicitudAmex.departamento.nombre"></v-text-field>
              <v-text-field label="Solicitante" box readonly
                :value="solicitudAmex.usuario_creacion.nombre"></v-text-field>
              <v-text-field label="Importe total solicitado" box readonly
                :value="formatCurrency(solicitudAmex.saldo_a_pagar)"></v-text-field>
              <v-divider class="mt-3 mb-3"></v-divider>
              <h3 class="grey--text">ESTADOS DE CUENTA</h3><br />
              <v-data-table :headers="headersEstadosCuenta" :items="solicitudAmex.estados_cuenta"
                class="elevation-1 text-center" hide-actions no-data-text="">
                <template slot="items" slot-scope="{ item }">
                  <tr>
                    <td>{{ formatDateTable(item.fecha_corte) }}</td>
                    <td>{{ formatDateTable(item.fecha_pago) }}</td>
                    <td>{{ formatPeriodo(item.periodo) }} </td>
                    <td>{{ item.tarjetahabiente }} </td>
                    <td>{{ item.asistente }} </td>
                    <td>{{ formatCurrency(item.saldo_a_pagar) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            <template v-if="tipoSolicitudComprobacionRepresentacion === true">
              <v-text-field label="Fecha de solicitud" box readonly :value="solicitud.fecha_creacion"></v-text-field>
              <v-text-field label="Tipo de Solicitud" box readonly :value="tipoSolicitudTexto"></v-text-field>
              <v-text-field v-if="solicitud.subtipo_atencion" label="Subtipo de atención " box readonly
                :value="subtipoAtencionTexto"></v-text-field>
              <v-text-field label="Empresa" box readonly :value="solicitud.idcat_empresa.descripcion"></v-text-field>
              <v-text-field label="Centro de costo" box readonly
                :value="solicitud.idcat_centro_costo.descripcion"></v-text-field>
              <v-text-field label="Departamento" box readonly
                :value="solicitud.idcat_departamento.descripcion"></v-text-field>
              <v-text-field label="Solicitante" box readonly :value="solicitud.nombre_responsable"></v-text-field>
              <v-text-field label="Puesto" box readonly :value="solicitud.puesto"></v-text-field>
              <v-text-field label="Importe total comprobado" box readonly
                :value="formatCurrency(solicitud.importe)"></v-text-field>
              <v-text-field label="Número de asistentes" box readonly
                :value="solicitud.numero_asistentes"></v-text-field>
              <v-text-field label="Forma de pago" box readonly :value="formaPagoTexto"></v-text-field>
              <v-divider class="mt-3 mb-3"></v-divider>
              <h3 class="grey--text">Datos Bancarios</h3><br />
              <v-text-field label="Banco" box readonly :value="solicitud.banco"></v-text-field>
              <v-text-field label="Número de cuenta" box readonly :value="solicitud.numero_cuenta"></v-text-field>
              <v-text-field label="Tarjeta" box readonly :value="solicitud.numero_tarjeta"></v-text-field>
              <v-text-field label="Referencia interbancaria" box readonly
                :value="solicitud.referencia_interbancaria"></v-text-field>
              <v-textarea v-model="solicitud.observaciones" label="Observaciones" box readonly rows="3" auto-grow />
            </template>
            <template v-if="tipoSolicitudRepresentacion === true">
              <v-text-field label="Fecha de solicitud" box readonly :value="solicitud.fecha_creacion"></v-text-field>
              <v-text-field label="Tipo de Solicitud" box readonly :value="tipoSolicitudTexto"></v-text-field>
              <v-text-field v-if="solicitud.subtipo_atencion" label="Subtipo de atención " box readonly
                :value="subtipoAtencionTexto"></v-text-field>
              <v-text-field label="Empresa" box readonly :value="solicitud.idcat_empresa.descripcion"></v-text-field>
              <v-text-field label="Centro de costo" box readonly
                :value="solicitud.idcat_centro_costo.descripcion"></v-text-field>
              <v-text-field label="Departamento" box readonly
                :value="solicitud.idcat_departamento.descripcion"></v-text-field>
              <v-text-field label="Solicitante" box readonly :value="solicitud.nombre_responsable"></v-text-field>
              <v-text-field label="Puesto" box readonly :value="solicitud.puesto"></v-text-field>
              <v-text-field label="Importe total solicitado" box readonly
                :value="formatCurrency(solicitud.importe)"></v-text-field>
              <v-text-field label="Número de asistentes" box readonly
                :value="solicitud.numero_asistentes"></v-text-field>
              <v-text-field label="Forma de pago" box readonly :value="formaPagoTexto"></v-text-field>
              <v-divider class="mt-3 mb-3"></v-divider>
              <h3 class="grey--text">Datos Bancarios</h3><br />
              <v-text-field label="Banco" box readonly :value="solicitud.banco"></v-text-field>
              <v-text-field label="Número de cuenta" box readonly :value="solicitud.numero_cuenta"></v-text-field>
              <v-text-field label="Tarjeta" box readonly :value="solicitud.numero_tarjeta"></v-text-field>
              <v-text-field label="Referencia interbancaria" box readonly
                :value="solicitud.referencia_interbancaria"></v-text-field>
              <v-textarea v-model="solicitud.observaciones" label="Observaciones" box readonly rows="3" auto-grow />
            </template>
            <template v-if="tipoSolicitudComprobacionAMEX === true">
              <v-layout row wrap>
                <v-flex xs4>
                  <h3 class="grey--text">GENERAL</h3>
                  </br>
                  <div class="campo">
                    <span class="label">Solicitante:</span>
                    <span class="valor">{{ solicitud.solicitante }}</span>
                  </div>
                  <div class="campo">
                    <span class="label">Estado cuenta:</span>
                    <span class="valor">{{ solicitud.idestado_cuenta_amex.tarjetahabiente }}</span>
                  </div>
                  <div class="campo">
                    <span class="label">Fecha Solicitud:</span>
                    <span class="valor">{{ formatDateShort(solicitud.fecha_creacion) }}</span>
                  </div>
                </v-flex>
              </v-layout>
              </br>

              <h3 class="grey--text">RESUMEN DEL ESTADO DE CUENTA</h3>
              <br />
              <v-data-table :headers="headersEC" :items="[solicitud.idestado_cuenta_amex]" :loading="loading"
                class="elevation-1" hide-actions>
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="{ item }">
                  <tr>
                    <td class="text-xs-center">{{ item.tarjetahabiente }}
                    </td>
                    <td class="text-xs-center">{{ formatDateShort(item.fecha_corte)
                    }}
                    </td>
                    <td class="text-xs-center">{{ formatDateShort(item.fecha_pago)
                    }}
                    </td>
                    <td class="text-xs-center">{{ formatCurrency(item.saldo_a_pagar) }}</td>
                  </tr>
                </template>
                <template slot="no-data">
                  <div class="text-xs-center">No se ha seleccionado estado de cuenta.</div>
                </template>
              </v-data-table>
              </br>

              <h3 class="grey--text">COMPROBANTES</h3>
              <br />
              <v-data-table :headers="headersComprobantes" :items="solicitud.comprobantes_amex" class="elevation-1"
                hide-default-footer>
                <template slot="items" slot-scope="{ item }">
                  <tr>
                    <td class="text-xs-center">{{ item.tipo_gasto }}</td>
                    <td class="text-xs-center">{{ (item.concepto) }}</td>
                    <td class="text-xs-center">{{ formatDateShort(item.fecha_timbrado) }}</td>
                    <td class="text-xs-center">{{ formatCurrency(item.subtotal) }}</td>
                    <td class="text-xs-center">{{ formatCurrency(item.iva) }}</td>
                    <td class="text-xs-center">{{ formatCurrency(item.descuento) }}</td>
                    <td class="text-xs-center">{{ formatCurrency(item.total) }}</td>
                    <td class="text-xs-center">{{ item.uuid }}</td>
                    <td class="text-xs-center">

                      <v-tooltip bottom>
                        <v-btn slot="activator" small icon @click="descargarArchivo(item.idcomprobante_amex, 'pdf')">
                          <v-icon>picture_as_pdf</v-icon>
                        </v-btn>
                        <span>Descargar PDF</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <v-btn slot="activator" small icon @click="descargarArchivo(item.idcomprobante_amex, 'foto')">
                          <v-icon>image</v-icon>
                        </v-btn>
                        <span>Descargar Foto</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <v-btn slot="activator" small icon @click="descargarArchivo(item.idcomprobante_amex, 'xml')">
                          <v-icon>code</v-icon>
                        </v-btn>
                        <span>Descargar XML</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <v-btn slot="activator" icon small @click="descargarArchivo(item.idcomprobante_amex, 'todo')">
                          <v-icon>archive</v-icon>
                        </v-btn>
                        <span>Descargar Todo</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            <template v-if="tipoReposicion === true">
              <v-layout row wrap>
                <!-- RESPONSABLE -->
                <v-flex xs4>
                  <h3 class="grey--text">RESPONSABLE</h3>
                  </br>
                  <div class="campo" v-for="(valor, key) in detalleReposicion.responsable" :key="key">
                    <span class="label">{{ key }}:</span>
                    <span class="valor">{{ valor }}</span>
                  </div>
                </v-flex>

                <!-- FONDO FIJO -->
                <v-flex xs4>
                  <h3 class="grey--text">FONDO FIJO</h3>
                  </br>
                  <div class="campo" v-for="(valor, key) in detalleReposicion.fondoFijo" :key="key">
                    <span class="label">{{ key }}:</span>
                    <span class="valor">{{ valor }}</span>
                  </div>
                </v-flex>

                <!-- GENERAL -->
                <v-flex xs4>
                  <h3 class="grey--text">GENERAL</h3>
                  </br>
                  <div class="campo" v-for="(valor, key) in detalleReposicion.general" :key="key">
                    <span class="label">{{ key }}:</span>
                    <span class="valor">{{ valor }}</span>
                  </div>
                </v-flex>
              </v-layout>
              </br>
              <h3 class="grey--text">FACTURAS</h3>
              <v-data-table :headers="headersFacturas" :items="detalleReposicion.facturas" hide-actions
                class="elevation-1">
                <template slot="items" slot-scope="props">
                  <td>{{ detalleReposicion.fondoFijo.Empresa }}</td>
                  <td>{{ props.item["Beneficiario"] }}</td>
                  <td>{{ props.item["RFC"] }}</td>
                  <td>{{ props.item["Tipo de gasto"] }}</td>
                  <td>{{ props.item["Concepto"] }}</td>
                  <td>{{ props.item["Centro de costos"] }}</td>
                  <td>{{ props.item["Folio"] }}</td>
                  <td>{{ props.item["Fecha de timbrado"] }}</td>
                  <td class="text-xs-right">
                    {{ Number(props.item.Subtotal).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
                  </td>
                  <td class="text-xs-right">
                    {{ Number(props.item.Descuento).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
                  </td>
                  <td class="text-xs-right">
                    {{ Number(props.item.IVA).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
                  </td>
                  <td class="text-xs-right">
                    <strong>{{ Number(props.item.Total).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
                      }}</strong>
                  </td>
                  <td>
                    <v-btn v-if="props.item.Foto" icon small @click="downloadDocument(props.item.Foto)"
                      title="Descargar Foto">
                      <v-icon color="blue">image</v-icon>
                    </v-btn>

                    <v-btn v-if="props.item.PDF" icon small @click="downloadDocument(props.item.PDF)"
                      title="Descargar PDF">
                      <v-icon color="red">picture_as_pdf</v-icon>
                    </v-btn>

                    <v-btn v-if="props.item.XML" icon small @click="downloadDocument(props.item.XML)"
                      title="Descargar XML">
                      <v-icon color="green">code</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>

            </template>
            <template v-if="!tipoReposicion" v-for="(elem, i) in detalle">
              <template v-if="elem.titulo === '__title__'">
                <h3 class="grey--text">{{ elem.valor }}</h3><br />
              </template>
              <template v-else-if="elem.titulo === '__divider__'">
                <v-divider></v-divider><br />
              </template>
              <template v-else-if="elem.titulo === '__resumen__'">
                <h3 class="grey--text">RESUMEN</h3><br />
                <v-data-table v-if="resumen.length" :headers="headersResumen" :items="tableResumen" class="elevation-1"
                  hide-actions no-data-text="">
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-right">{{ props.item.tipo_gasto }}</td>
                    <td class="text-xs-right">{{ props.item.concepto }}</td>
                    <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                    <!--<td class="text-xs-right">{{ props.item.proveedor }}</td>-->
                    <td class="text-xs-right">{{ props.item.subtotal }}</td>
                    <td class="text-xs-right">{{ props.item.iva }}</td>
                    <td class="text-xs-right">{{ props.item.total }}</td>
                  </template>
                </v-data-table>
                <br />
              </template>
              <v-btn v-else-if="elem.titulo === '__id__' && roles.indexOf('contabilidad') >= 0" flat :loading="loading"
                color="blue-grey" class="white--text" @click="id_documento = elem.valor; dialogNewConcept = true">
                Actualizar concepto
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__Pagare') >= 0" flat :loading="loading" color="blue-grey"
                class="white--text" @click="downloadDocument(elem.valor)">
                Pagaré
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__Responsiva') >= 0" flat :loading="loading" color="blue-grey"
                class="white--text" @click="downloadDocument(elem.valor)">
                Carta responsiva
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__Foto') >= 0" flat :loading="loading" color="blue-grey"
                class="white--text" @click="downloadDocument(elem.valor)">
                Foto
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__PDF') >= 0" flat :loading="loading" color="blue-grey"
                class="white--text" @click="downloadDocument(elem.valor)">
                PDF
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__XML') >= 0" flat :loading="loading" color="blue-grey"
                class="white--text" @click="downloadDocument(elem.valor)">
                XML
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <template v-else-if="elem.titulo !== '__id__' && elem.valor !== ''">
                <v-text-field v-if="(elem.titulo.search('__Importe') >= 0 && elem.titulo.search('__Importe con letra') < 0) || elem.titulo.search('Fondo fijo autorizado') >= 0 ||
                  elem.titulo.search('__Nuevo importe') >= 0 || elem.titulo.search('__Importe por reembolsar') >= 0 ||
                  elem.titulo.search('__Subtotal') >= 0 || elem.titulo.search('__Descuento') >= 0 ||
                  elem.titulo.search('__IVA') >= 0 || elem.titulo.search('__Total') >= 0 ||
                  elem.titulo.search('__Importe total') >= 0" :label="elem.titulo.replace(/__(\d+)__/, '')" box
                  readonly :value="elem.valor.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')" prefix="$"
                  suffix="MXN"></v-text-field>
                <v-text-field v-else :label="elem.titulo.replace(/__(\d+)__/, '')" box readonly
                  :value="elem.valor"></v-text-field>
              </template>
            </template><br />
            <h3 v-show="firmas.length > 0" class="grey--text">FIRMAS</h3><br />
            <v-list v-show="firmas.length > 0" three-line dark>
              <template v-for="(item, i) in firmas">
                <v-list-tile class="pb-2 pt-2">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                    <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                    <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                      v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-show="(i + 1) < firmas.length"></v-divider>
              </template>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeDetailReq()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewConcept" persistent width="450">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nuevo concepto</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-select v-model="nuevo_conceptoo" :items="conceptos" item-text="descripcion" item-value="id"
              label="Concepto"></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeNewConcept()">Cerrar</v-btn>
          <v-btn color="blue-grey" class="white--text" @click.native="updateNewConcept()">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionRemove" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea marcar como leída la notificación?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionRemove = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="removeNotification()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionReject" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea rechazar la solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReject = false">Cancelar</v-btn>
          <v-btn flat color="error" @click.native="rejectRequest()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionApprove" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea aprobar la solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionApprove = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="approveRequest()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import services from "@/config/services";
import axios from "axios";
import download from "downloadjs";
import { validationMixin } from "vuelidate";
import { maxLength } from "vuelidate/lib/validators";

export default {
  name: "notificaciones",
  mixins: [validationMixin],
  validations: {
    notificaciones: {
      $each: {
        observaciones: { maxLength: maxLength(300) }
      }
    }
  },
  data: () => ({
    tipoSolicitudComprobacionRepresentacion: false,
    tipoSolicitudRepresentacion: false,
    tipoSolicitudAmex: false,
    tipoSolicitudComprobacionAMEX: false,
    tipoReposicion: false,
    solicitudAmex: {
      estados_cuenta: []
    },
    headersFacturas: [
      { text: 'Empresa', value: '__id__', align: 'start', sortable: false },
      { text: 'Beneficiario', value: 'Beneficiario', sortable: false },
      { text: 'RFC', value: 'RFC', sortable: false },
      { text: 'Tipo de gasto', value: 'Tipo de gasto', sortable: false },
      { text: 'Concepto', value: 'Concepto', sortable: false },
      { text: 'Centro de costos', value: 'Centro de costos', sortable: false },
      { text: 'Folio', value: 'Folio', sortable: false },
      { text: 'Fecha de Timbrado', value: 'Fecha de Timbrado', sortable: false },
      { text: 'Subtotal', value: 'Subtotal', align: 'end', sortable: false },
      { text: 'Descuento', value: 'Descuento', align: 'end', sortable: false },
      { text: 'IVA', value: 'IVA', align: 'end', sortable: false },
      { text: 'Total', value: 'Total', align: 'end', sortable: false },
      { text: 'Ver', value: 'archivos', sortable: false },
    ],
    headersComprobantes: [
      { text: 'Tipo de Gasto', value: 'fecha_corte' },
      { text: 'Concepto', value: 'fecha_pago' },
      { text: 'Fecha de Timbrado', value: 'periodo' },
      { text: 'Subtotal', value: 'tarjetahabiente' },
      { text: 'IVA', value: 'asistente' },
      { text: 'Descuento', value: 'asistente' },
      { text: 'Total', value: 'saldo_a_pagar' },
      { text: 'UUID', value: 'saldo_a_pagar' },
      { text: 'Acciones', value: 'saldo_a_pagar', sortable: false }
    ],
    headersEstadosCuenta: [
      { text: "Fecha Corte", value: "fecha_corte", sortable: false },
      { text: "Fecha Pago", value: "fecha_pago", sortable: false },
      { text: "Periodo", value: "periodo", sortable: false },
      { text: "Tarjetahabiente", value: "tarjetahabiente", sortable: false },
      { text: "Asistente", value: "asistente", sortable: false },
      { text: "Saldo a Pagar", value: "saldo_a_pagar", sortable: false }
    ], headersEC: [
      {
        text: "Tarjetahabiente",
        value: "tarjetahabiente",
        sortable: false,
        class: "text-xs-center"
      },
      {
        text: "Fecha Corte",
        value: "fecha_corte",
        sortable: false,
        class: "text-xs-center"
      },
      {
        text: "Fecha Pago",
        value: "fecha_pago",
        sortable: false,
        class: "text-xs-center"
      },
      {
        text: "Saldo a pagar",
        value: "saldo_a_pagar",
        sortable: false,
        class: "text-xs-center"
      },
    ],
    tituloPlus: "",
    loading: false,
    success: false,
    error: false,
    msgSuccess: "",
    msgError: "",
    dialogDetailReq: false,
    dialogNewConcept: false,
    questionRemove: false,
    questionReject: false,
    questionApprove: false,
    roles: [],
    tab_activo: null,
    notificaciones: [],
    leidos: [],
    pagina_notificaciones: 1,
    pagina_leidos: 1,
    total_notificaciones: 0,
    total_leidos: 0,
    notificacion: {
      id: null,
      nombre: "",
      tipo: "",
      movimiento: "",
      fecha_registro: "",
      fecha_actualizacion: "",
      observaciones: "",
      firma: ""
    },
    observaciones: [],
    conceptos: [],
    nuevo_conceptoo: "",
    id_notificacion: "",
    id_documento: "",
    detalle: [],
    resumen: [],
    firmas: [],
    headersResumen: [
      {
        text: "TIPO DE GASTO",
        align: "center",
        sortable: false,
        value: "tipo_gasto"
      },
      { text: "CONCEPTO", align: "center", sortable: false, value: "concepto" },
      {
        text: "FECHA DE TIMBRADO",
        align: "center",
        sortable: false,
        value: "fecha_timbrado"
      },
      /*{ text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },*/
      {
        text: "SUB TOTAL",
        align: "center",
        sortable: false,
        value: "subtotal"
      },
      { text: "IVA", align: "center", sortable: false, value: "iva" },
      { text: "TOTAL", align: "center", sortable: false, value: "total" }
    ]
  }),
  mounted() {
    this.refresh();
    this.ws("get", "check").then(res => {
      if (res.ok) {
        this.roles = res.data.roles;
      }
    });
  },
  computed: {
    tipoSolicitudTexto() {
      if (this.solicitud.tipo_gasto === 'representacion') {
        return 'Gastos de representación'
      }
      if (this.solicitud.tipo_gasto === 'atencion_personal') {
        return 'Atención al personal'
      }
      return this.solicitud.tipo_gasto || ''
    },
    subtipoAtencionTexto() {
      const map = {
        comidas_trabajo: 'Comida de Trabajo',
        reuniones_integracion: 'Reuniones de Integración'
      }
      return map[this.solicitud.subtipo_atencion] || this.solicitud.subtipo_atencion
    },
    formaPagoTexto() {
      const map = {
        cheque: 'Cheque',
        transferencia: 'Transferencia'
      }
      return map[this.solicitud.tipo_pago] || this.solicitud.tipo_pago
    },
    tableResumen() {
      let resumen = [];
      let detalle = {};
      for (let i = 0; i < this.resumen.length; i++) {
        let tipo_gasto = this.resumen[i].tipo_gasto;
        let concepto = this.resumen[i].concepto;
        let fecha_timbrado = this.resumen[i].fecha_timbrado;
        let proveedor = this.resumen[i].razon_social;
        let subtotal = this.resumen[i].subtotal;
        let iva = this.resumen[i].iva;
        let total = this.resumen[i].total;
        if (tipo_gasto === "deducible") {
          tipo_gasto = "DEDUCIBLE";
        } else if (tipo_gasto === "no_deducible") {
          tipo_gasto = "NO DEDUCIBLE";
        }
        if (!detalle[tipo_gasto]) {
          detalle[tipo_gasto] = {};
        }
        if (!detalle[tipo_gasto][concepto]) {
          detalle[tipo_gasto][concepto] = {
            fecha_timbrado: fecha_timbrado,
            proveedor: proveedor,
            subtotal: 0,
            iva: 0,
            total: 0
          };
        }
        detalle[tipo_gasto][concepto].subtotal += subtotal;
        detalle[tipo_gasto][concepto].iva += iva;
        detalle[tipo_gasto][concepto].total += total;
      }
      let keysTipoGasto = Object.keys(detalle);
      for (let i = 0; i < keysTipoGasto.length; i++) {
        let keysConcepto = Object.keys(detalle[keysTipoGasto[i]]);
        for (let j = 0; j < keysConcepto.length; j++) {
          resumen.push({
            tipo_gasto: keysTipoGasto[i],
            concepto: keysConcepto[j],
            fecha_timbrado:
              detalle[keysTipoGasto[i]][keysConcepto[j]].fecha_timbrado,
            proveedor: detalle[keysTipoGasto[i]][keysConcepto[j]].proveedor,
            subtotal: detalle[keysTipoGasto[i]][keysConcepto[j]].subtotal,
            iva: detalle[keysTipoGasto[i]][keysConcepto[j]].iva,
            total: detalle[keysTipoGasto[i]][keysConcepto[j]].total
          });
        }
      }
      for (let i = 0; i < resumen.length; i++) {
        resumen[i].fecha_timbrado = resumen[i].fecha_timbrado.split("T")[0];
        resumen[i].subtotal =
          "$" +
          resumen[i].subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        resumen[i].iva =
          "$" + resumen[i].iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        resumen[i].total =
          "$" +
          resumen[i].total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return resumen;
    }
  },
  methods: {
    getNotificacionHeader(item) {
      return `${this.getTipoDesc(item.tipo)} - ${item.movimiento} - ${item.fecha_registro}`;
    },
    getTipoDesc(tipo) {
      let tipos = {
        gastos_amex_solicitud: 'Gastos AMEX (Solicitud)',
        gastos_amex_comprobacion: 'Gastos AMEX (Comprobación)',
        gastos_representacion_solicitud: 'Gastos Representación (Solicitud)',
        gastos_representacion_comprobacion: 'Gastos Representación (Comprobación)'
      }

      if (tipos[tipo])
        return tipos[tipo]

      return tipo
    },
    handleEsc() {
      this.closeDetailReq()
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatPeriodo(periodo) {
      if (!periodo || periodo.length !== 6) return "";
      const year = periodo.slice(0, 4);
      const month = periodo.slice(4, 6);
      return `${year}-${month}`;
    },
    formatCurrency(value) {
      if (!value) return "$ 0.00 MXN";
      const number = parseFloat(value);
      return (
        "$ " + number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " MXN"
      );
    },
    formatDateTable(date) {
      if (!date) return "";
      const options = {
        timeZone: "America/Mexico_City",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      };
      const formatter = new Intl.DateTimeFormat("es-MX", options);
      const formatted = formatter.format(new Date(date));
      const [dia, mes, anio, hora] = formatted.replace(",", "").split(" ");
      const mesUpper = mes.toUpperCase();
      return `${dia}-${mesUpper}-${anio} ${hora}`;
    },
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    refresh() {
      this.loading = true;
      this.notificaciones = [];
      this.leidos = [];
      this.pagina_notificaciones = 1;
      this.pagina_leidos = 1;
      setTimeout(() => {
        this.ws("get", "notificaciones", {
          pagina_notificaciones: this.pagina_notificaciones,
          pagina_leidos: this.pagina_leidos
        })
          .then(res => {
            if (res.ok) {
              this.notificaciones = res.data.notificaciones;
              this.leidos = res.data.leidos;
              this.total_notificaciones = res.data.total_notificaciones;
              this.total_leidos = res.data.total_leidos;
              this.observaciones = [];
              for (let i = 0; i < this.notificaciones.length; i++) {
                this.observaciones.push(this.notificaciones[i].observaciones);
              }
            } else {
              this.notificacion = {
                id: null,
                nombre: "",
                tipo: "",
                movimiento: "",
                fecha_registro: "",
                fecha_actualizacion: "",
                observaciones: "",
                firma: ""
              };
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }, 500);
    },
    observacionesErrors(i) {
      const errors = [];
      if (!this.$v.notificaciones.$each[i].observaciones.$dirty) return errors;
      !this.$v.notificaciones.$each[i].observaciones.maxLength &&
        errors.push("El campo excede la longitud máxima");
      return errors;
    },
    close() {
      this.$v.$reset();
      this.notificacion = {
        id: null,
        nombre: "",
        tipo: "",
        movimiento: "",
        fecha_registro: "",
        fecha_actualizacion: "",
        observaciones: "",
        firma: ""
      };
    },
    removeNotification() {
      this.questionRemove = false;
      this.loading = true;
      let data = {
        id: this.notificacion.id
      };
      this.ws("post", "eliminarNotificacion", data).then(res => {
        if (res.ok) {
          this.close();
          this.refresh();
          this.success = true;
          this.msgSuccess = res.message;
        } else {
          this.loading = false;
          this.error = true;
          this.msgError = res.message;
        }
      });
    },
    async rejectRequest() {
      this.questionReject = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.notificacion.observaciones !== "") {
          if (this.notificacion.tipo == "gastos_amex_solicitud") {
            this.loading = true;
            let id = this.notificacion.id_sol;
            const jwt = this.$session.get("jwt");
            const headers = { Authorization: "Bearer " + jwt };
            const url = services.routes.amexSolicitudRechazar.replace(
              ":idsolicitud_amex",
              id
            );
            try {
              const response = await axios.post(
                url,
                { observaciones: this.notificacion.observaciones },
                { headers }
              );
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = response.data.mensaje;
            } catch (err) {
              this.error = true;
              if (err && err.response && err.response.data) {
                this.msgError =
                  err.response.data.message || "Error del servidor";
              } else {
                this.msgError = err.message || "Error desconocido";
              }
              console.error(err);
            } finally {
              this.loading = false;
            }
            return;
          }
          if (this.notificacion.tipo == "gastos_representacion_comprobacion") {
            this.loading = true;
            let id = this.notificacion.id_sol;
            const jwt = this.$session.get("jwt");
            const headers = { Authorization: "Bearer " + jwt };
            const url = services.routes.representacionComprobacionSolicitudesRechazar.replace(
              ":idsolicitud",
              id
            );
            try {
              const response = await axios.post(
                url,
                { observaciones: this.notificacion.observaciones },
                { headers }
              );
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = response.data.mensaje;
            } catch (err) {
              this.error = true;
              if (err && err.response && err.response.data) {
                this.msgError =
                  err.response.data.message || "Error del servidor";
              } else {
                this.msgError = err.message || "Error desconocido";
              }
              console.error(err);
            } finally {
              this.loading = false;
            }
            return;
          }
          if (this.notificacion.tipo == "gastos_representacion_solicitud") {
            this.loading = true;
            let id = this.notificacion.id_sol;
            const jwt = this.$session.get("jwt");
            const headers = { Authorization: "Bearer " + jwt };
            const url = services.routes.representacionSolicitudesRechazar.replace(
              ":idsolicitud",
              id
            );
            try {
              const response = await axios.post(
                url,
                { observaciones: this.notificacion.observaciones },
                { headers }
              );
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = response.data.mensaje;
            } catch (err) {
              this.error = true;
              if (err && err.response && err.response.data) {
                this.msgError =
                  err.response.data.message || "Error del servidor";
              } else {
                this.msgError = err.message || "Error desconocido";
              }
              console.error(err);
            } finally {
              this.loading = false;
            }
            return;
          }
          if (this.notificacion.tipo == "gastos_amex_comprobacion") {
            this.loading = true;
            let id = this.notificacion.id_sol;
            const jwt = this.$session.get("jwt");
            const headers = { Authorization: "Bearer " + jwt };
            const url = services.routes.amexComprobacionRechazar.replace(
              ":idsolicitud",
              id
            );
            try {
              const response = await axios.post(
                url,
                { observaciones: this.notificacion.observaciones },
                { headers }
              );
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = response.data.mensaje;
            } catch (err) {
              this.error = true;
              if (err && err.response && err.response.data) {
                this.msgError =
                  err.response.data.message || "Error del servidor";
              } else {
                this.msgError = err.message || "Error desconocido";
              }
              console.error(err);
            } finally {
              this.loading = false;
            }
            return;
          }
          this.loading = true;
          let data = {
            id: this.notificacion.id,
            observaciones: this.notificacion.observaciones
          };
          this.ws("post", "rechazarSolicitud", data).then(res => {
            if (res.ok) {
              this.close();
              this.refresh();
              this.success = true;
              this.msgSuccess = res.message;
            } else {
              this.loading = false;
              this.error = true;
              this.msgError = res.message;
            }
          });
        } else {
          this.error = true;
          this.msgError = "El campo observaciones es obligatorio";
        }
      }
    },
    async approveRequest() {
      this.questionApprove = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.notificacion.tipo == "gastos_amex_solicitud") {
          this.loading = true;
          let id = this.notificacion.id_sol;
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.amexSolicitudAprobar.replace(
            ":idsolicitud_amex",
            id
          );
          try {
            const response = await axios.post(
              url,
              { observaciones: this.notificacion.observaciones },
              { headers }
            );
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = response.data.mensaje;
          } catch (err) {
            this.error = true;
            if (err && err.response && err.response.data) {
              this.msgError = err.response.data.message || "Error del servidor";
            } else {
              this.msgError = err.message || "Error desconocido";
            }
            console.error(err);
          } finally {
            this.loading = false;
          }
          return;
        }
        if (this.notificacion.tipo == "gastos_representacion_comprobacion") {
          this.loading = true;
          let id = this.notificacion.id_sol;
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.representacionComprobacionSolicitudesAprobar.replace(
            ":idsolicitud",
            id
          );
          try {
            const response = await axios.post(
              url,
              { observaciones: this.notificacion.observaciones },
              { headers }
            );
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = response.data.mensaje;
          } catch (err) {
            this.error = true;
            if (err && err.response && err.response.data) {
              this.msgError = err.response.data.message || "Error del servidor";
            } else {
              this.msgError = err.message || "Error desconocido";
            }
            console.error(err);
          } finally {
            this.loading = false;
          }
          return;
        }
        if (this.notificacion.tipo == "gastos_representacion_solicitud") {
          this.loading = true;
          let id = this.notificacion.id_sol;
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.representacionSolicitudesAprobar.replace(
            ":idsolicitud",
            id
          );
          try {
            const response = await axios.post(
              url,
              { observaciones: this.notificacion.observaciones },
              { headers }
            );
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = response.data.mensaje;
          } catch (err) {
            this.error = true;
            if (err && err.response && err.response.data) {
              this.msgError = err.response.data.message || "Error del servidor";
            } else {
              this.msgError = err.message || "Error desconocido";
            }
            console.error(err);
          } finally {
            this.loading = false;
          }
          return;
        }
        if (this.notificacion.tipo == "gastos_amex_comprobacion") {
          console.log("entro amex comprobacion")
          this.loading = true;
          let id = this.notificacion.id_sol;
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.amexComprobacionAprobar.replace(
            ":idsolicitud",
            id
          );
          try {
            const response = await axios.post(
              url,
              { observaciones: this.notificacion.observaciones },
              { headers }
            );
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = response.data.mensaje;
          } catch (err) {
            this.error = true;
            if (err && err.response && err.response.data) {
              this.msgError = err.response.data.message || "Error del servidor";
            } else {
              this.msgError = err.message || "Error desconocido";
            }
            console.error(err);
          } finally {
            this.loading = false;
          }
          return;
        }
        this.loading = true;
        let data = {
          id: this.notificacion.id,
          observaciones: this.notificacion.observaciones
        };
        this.ws("post", "aprobarSolicitud", data).then(res => {
          if (res.ok) {
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = res.message;
          } else {
            this.loading = false;
            this.error = true;
            this.msgError = res.message;
          }
        });
      }
    },
    closeDetailReq() {
      this.id_notificacion = "";
      this.id_documento = "";
      this.nuevo_conceptoo = "";
      this.detalle = [];
      this.resumen = [];
      this.firmas = [];
      this.dialogDetailReq = false;
    },
    closeNewConcept() {
      this.id_documento = "";
      this.nuevo_conceptoo = "";
      this.dialogNewConcept = false;
    },
    updateNewConcept() {
      if (this.roles.indexOf("contabilidad") >= 0) {
        if (this.nuevo_conceptoo != "") {
          let data = {
            id_notificacion: this.id_notificacion,
            id_documento: this.id_documento,
            concepto: this.nuevo_conceptoo
          };
          this.closeNewConcept();
          this.loading = true;
          this.ws("post", "actualizarConceptoDocumento", data)
            .then(res => {
              if (res.ok) {
                this.closeDetailReq();
                this.success = true;
                this.msgSuccess = res.message;
              } else {
                this.loading = false;
                this.error = true;
                this.msgError = res.message;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.error = true;
          this.msgError = "Debe seleccionar un concepto disponible";
        }
      } else {
        this.error = true;
        this.msgError =
          "No cuenta con los permisos necesarios para realizar esta acción";
      }
    },
    downloadDocument(doc) {
      let nombre = doc.nombre;
      let data = doc.data;
      if (data !== null && data !== "") {
        let mimetype = data.split(";")[0].split(":")[1];
        download(data, nombre, mimetype);
      } else {
        this.error = true;
        this.msgError = "El documento no se encuentra disponible";
      }
    },
    transformarDetalle(data) {
      const salida = {
        responsable: {},
        fondoFijo: {},
        general: {},
        facturas: []
      };

      for (const item of data.detalle) {
        // ignorar si es solo título/divisor
        if (typeof item === "string") continue;

        // FACTURAS (si trae un id, asumimos que es comprobante)
        if (item["__id__"]) {
          const factura = {};
          for (const [k, v] of Object.entries(item)) {
            // eliminar el prefijo "__X__" si existe
            let cleanKey = k.replace(/^__\d+__/, "").trim();
            factura[cleanKey] = v;
          }
          salida.facturas.push(factura);
          continue;
        }

        // RESPONSABLE
        if (item["__0__Nombre"]) {
          for (const [k, v] of Object.entries(item)) {
            let cleanKey = k.replace(/^__\d+__/, "").trim();
            salida.responsable[cleanKey] = v;
          }
          continue;
        }

        // FONDO FIJO
        if (item["__0__Área"]) {
          for (const [k, v] of Object.entries(item)) {
            let cleanKey = k.replace(/^__\d+__/, "").trim();
            salida.fondoFijo[cleanKey] = v;
          }
          continue;
        }
        if (item["Fondo fijo autorizado"]) {
          salida.fondoFijo["Autorizado"] = item["Fondo fijo autorizado"];
          continue;
        }

        // GENERAL
        if (item["__0__Tipo de solicitud"]) {
          for (const [k, v] of Object.entries(item)) {
            let cleanKey = k.replace(/^__\d+__/, "").trim();
            salida.general[cleanKey] = v;
          }
          continue;
        }
      }


      this.detalleReposicion = salida
      this.firmas = data.firmas;
      console.log(this.detalleReposicion)
      this.dialogDetailReq = true;

    },
    prepareDetailForm(data) {
      for (let i = 0; i < data.detalle.length; i++) {
        let keys = [];
        for (var k in data.detalle[i]) {
          if (data.detalle[i].hasOwnProperty(k)) {
            keys.push(k);
          }
        }
        keys.sort();
        for (let j = 0; j < keys.length; j++) {
          this.detalle.push({
            titulo: keys[j],
            valor: data.detalle[i][keys[j]]
          });
        }
      }
      this.resumen = data.resumen;
      this.firmas = data.firmas;
      this.conceptos = data.conceptos;
      this.dialogDetailReq = true;
    },
    async descargarArchivo(id, tipo) {
      try {
        const jwt = this.$session.get("jwt");
        const headers = {
          Authorization: "Bearer " + jwt
        };

        const params = new URLSearchParams();
        params.append("idcomprobante_amex", id);
        params.append("tipo", tipo);

        const response = await axios.get(
          `${services.routes.amexComprobanteDescarga}?${params.toString()}`,
          {
            headers,
            responseType: "blob"
          }
        );
        const disposition = response.headers["content-disposition"];
        if (!disposition
        ) {
          this.msgError = "Archivo no Disponible";
          this.error = true;
          return
        }
        if (response.data.statusText == 'No Content') {
          this.msgError = "Archivo no Disponible";
          this.error = true;;
          return
        }
        let filename = "archivo";
        if (disposition && disposition.includes("filename=")) {
          filename = disposition.split("filename=")[1].replace(/["']/g, "");
        }
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error("Error al descargar comprobante:", err);
        this.alert = true;
        if (err && err.response && err.response.data && err.response.data.message) {
          this.msgError = err.response.data.message;
        } else if (err && err.message) {
          this.msgError = err.message;
        } else {
          this.msgError = "Error al descargar el comprobante";
        }
      }
      return
    },
    async showDetailReq(id, item) {
      this.loading = true;
      this.tipoSolicitudRepresentacion = false;
      this.tipoSolicitudAmex = false;
      this.tipoSolicitudComprobacionAMEX = false;
      this.tipoReposicion = false
      this.tipoSolicitudComprobacionRepresentacion = false
      this.tituloPlus = "";
      if (item.tipo == 'Reposición') {
        this.tipoReposicion = true
      }
      if (item.tipo == "gastos_amex_solicitud") {
        this.tituloPlus = "de Gastos AMEX";
        id = item.id_sol;
        try {
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.amexSolicitudesDetalle.replace(
            ":idsolicitud_amex",
            id
          );
          const { data } = await axios.get(url, { headers });
          console.log(data);
          this.tipoSolicitudAmex = true;
          this.solicitudAmex = data;
          this.dialogDetailReq = true;
        } catch (err) {
          console.error("Error al cargar detalle:", err);
        } finally {
          this.loading = false;
        }
        return;
      }
      if (item.tipo == "gastos_representacion_comprobacion") {
        this.tituloPlus = "de Comprobación de Gastos de Representación";
        id = item.id_sol;
        try {
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.representacionComprobacionSolicitudDetalle.replace(
            ":id",
            id
          );
          const { data } = await axios.get(url, { headers });
          this.tipoSolicitudComprobacionRepresentacion = true;
          this.solicitud = data.idsolicitud_gasto_representacion;
          this.solicitud.importe = data.importe_total
          this.solicitud.fecha_creacion = data.fecha_creacion
          this.firmas = data.firmas
          this.dialogDetailReq = true;
        } catch (err) {
          console.error("Error al cargar detalle:", err);
        } finally {
          this.loading = false;
        }
        return;
      }
      if (item.tipo == "gastos_representacion_solicitud") {
        this.tituloPlus = "de Gastos de Representacion";
        console.log(item)
        id = item.id_sol;
        try {
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.representacionSolicitudesDetalle.replace(
            ":id",
            id
          );
          const { data } = await axios.get(url, { headers });
          this.tipoSolicitudRepresentacion = true;
          this.solicitud = data;
          this.firmas = data.firmas
          this.dialogDetailReq = true;
        } catch (err) {
          console.error("Error al cargar detalle:", err);
        } finally {
          this.loading = false;
        }
        return;
      }
      if (item.tipo == "gastos_amex_comprobacion") {
        this.tituloPlus = "de Gastos AMEX (Comprobación)";
        id = item.id_sol;
        try {
          const jwt = this.$session.get("jwt");
          const headers = { Authorization: "Bearer " + jwt };
          const url = services.routes.amexComprobacionDetalle.replace(
            ":id",
            id
          );
          const { data } = await axios.get(url, { headers });
          this.tipoSolicitudComprobacionAMEX = true;
          this.solicitud = data;
          this.firmas = data.firmas
          this.dialogDetailReq = true;
        } catch (err) {
          console.error("Error al cargar detalle:", err);
        } finally {
          this.loading = false;
        }
        return;
      }
      this.ws("get", "detalleCompletoSolicitud", { id })
        .then(res => {
          if (res.ok) {
            this.id_notificacion = id;
            if (this.tipoReposicion) {
              this.transformarDetalle(res.data)
            } else {
              this.prepareDetailForm(res.data);
            }
          } else {
            this.loading = false;
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newPage(side, inbox) {
      this.loading = true;
      let pagina_notificaciones = this.pagina_notificaciones;
      let pagina_leidos = this.pagina_leidos;
      if (inbox === "notificaciones") {
        if (side === "back") {
          pagina_notificaciones -= 1;
        } else if (side === "next") {
          pagina_notificaciones += 1;
        }
      } else if (inbox === "leidos") {
        if (side === "back") {
          pagina_leidos -= 1;
        } else if (side === "next") {
          pagina_leidos += 1;
        }
      }
      this.ws("get", "notificaciones", { pagina_notificaciones, pagina_leidos })
        .then(res => {
          if (res.ok) {
            this.notificaciones = res.data.notificaciones;
            this.leidos = res.data.leidos;
            this.total_notificaciones = res.data.total_notificaciones;
            this.total_leidos = res.data.total_leidos;
            this.observaciones = [];
            for (let i = 0; i < this.notificaciones.length; i++) {
              this.observaciones.push(this.notificaciones[i].observaciones);
            }
            this.pagina_notificaciones = pagina_notificaciones;
            this.pagina_leidos = pagina_leidos;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
/* Solo se aplica a diálogos con content-class="dialogo-detalle" */
.dialogo-detalle.v-dialog {
  width: 100% !important;
  /* o 90% */
  max-width: 1800px !important;
}

.dialogo-detalle .v-card {
  width: 100% !important;
  max-width: none !important;
}



.campo {
  display: flex;
  margin-bottom: 4px;
}

.label {
  font-weight: bold;
  min-width: 160px;
  /* Ajusta este ancho para que todos los valores se alineen */
  display: inline-block;
}

.valor {
  flex: 1;
}
</style>